import React, { useEffect, useState } from 'react';

// Spinner
import PulseLoader from 'react-spinners/PulseLoader';


// Appt Components
import Box from '../../components/simple/box/Box.js';
import DateTime from '../../components/compound/dateTime/DateTime.js';
import Form from '../../components/simple/form/Form.js';
import FormField from '../../components/simple/formField/FormField.js';
import Divider from '../../components/simple/divider/Divider.js';
import H2 from '../../components/simple/heading/H2.js';
import NotificationLayer from '../../components/compound/notification/NotificationLayer.js';
import OptionButtons from '../../components/compound/optionButtons/OptionButtons.js';
import ResponsiveGrid from '../../components/compound/responsiveGrid/ResponsiveGrid.js';
import Select from '../../components/simple/input/Select.js';
import TextArea from '../../components/simple/input/TextArea.js';
import TextInput from '../../components/simple/input/TextInput.js';
import Text from '../../components/simple/text/Text.js';
import RadioButtonGroup from '../../components/simple/input/RadioButtonGroup.js';
import DataTable from '../../components/simple/dataTable/DataTable.js';
import LocalStorageService from '../../services/LocalStorageService.js';
import { getRecordTerm } from '../../services/TermsService';

import CommentsForm from './CommentsForm.js';

import { capitalize, lowercase } from '../../utils/text.js';
import constants from '../../utils/constants.js';

import FontAwesome from '../../components/compound/fontAwesome/FontAwesome.js';
import ActionButton from '../../components/compound/actionButton/ActionButton.js';
import LocationSelection from '../../components/compound/locationSelection/LocationSelection.js';
import { Button } from 'grommet';

const questionTextStyle = {
  'margin-right': '12px',
  'margin-top': '6px',
  'margin-bottom': '0px',
  'margin-left': '0px',
  'font-size': '14px',
  'line-height': '20px',
  'font-weight': '700',
};

function IncidentReport(props) {
  const [loading, setLoading] = useState(false);
  const [localIncidentValues, setLocalIncidentValues] = useState(
    props.incidentValues,
  );
  const [interventionAddButton, setInterventionAddButton] = useState(false);
  const [interventionColumns, setInterventionDataColumns] = useState();
  const [mappedInterventions, setMappedInterventions] = useState([]);
  const [questions, setQuestions] = useState(props.questions);
  const terms = LocalStorageService.get('terms');
  const [editingDisabled] = useState(props.formId && props.status !== 'draft');

  const [studentValues, setStudentValues] = useState(props.studentValues);
  const [userValues, setUserValues] = useState(props.userValues);

  const [reportByValues, setReportByValues] = useState(props.userValues);
  const [staffInvolvedValues, setStaffInvolvedValues] = useState(props.userValues);
  const [otherServiceUserValues, setOtherServiceUserValues] = useState(props.studentValues);


  useEffect(() => {
    setStudentValues(props.studentValues);
    setOtherServiceUserValues(props.studentValues);
  }, [props.studentValues]);

  useEffect(() => {
    setUserValues(props.userValues);
    setReportByValues(props.userValues);
    setStaffInvolvedValues(props.userValues);
  }, [props.userValues]);

  // Don't allow change of tab
  const [stayOnTab, setStayOnTab] = useState(false);
  const removeIntervention = data => {
    const newInterventions = props.interventions.filter(
      item => item.interventionKey !== data.interventionKey,
    );

    props.setIntervention(newInterventions);
  };
  const addIntervention = () => {
    const intervention = {
      interventionKey: props.interventions.length,
      injurySufferedBy: localIncidentValues.injurySufferedBy,
      injury: localIncidentValues.injury,
      treatment: localIncidentValues.treatment,
      injurySufferedName: localIncidentValues.injurySufferedName,
      injuryTreatedBy: localIncidentValues.injuryTreatedBy,
    };
    props.setIntervention(interventions => [...interventions, intervention]);

    setLocalIncidentValues(localIncidentValues => ({
      ...localIncidentValues,
      injurySufferedBy: '',
      injury: '',
      treatment: '',
      injurySufferedName: '',
      injuryTreatedBy: ''
    }));
    setInterventionAddButton(false);
  };

  useEffect(() => {
    setInterventionDataColumns([
      {
        property: 'injurySufferedBy',
        header: (
          <Text pad="none" margin="none">
            Injury Suffered by
          </Text>
        ),
      },
      {
        property: 'injury',
        header: <Text>Injury</Text>,
      },
      {
        property: 'treatment',
        header: <Text>Treatment</Text>,
      },
      {
        property: 'injurySufferedName',
        header: <Text>Name</Text>,
      },
      {
        property: 'injuryTreatedBy',
        header: <Text>Treated By</Text>,
      },
      {
        property: 'actions',
        render: datum => (
          <Box direction="row">
            {!editingDisabled && <ActionButton
              label={
                <Text color="besmartOrange">
                  <FontAwesome icon={['fal', 'minus-circle']} />
                </Text>
              }
              margin={{ horizontal: 'xsmall' }}
              style={{ background: 'besmartOrange' }}
              onClick={() => removeIntervention(datum)}
              target="_self"
            />}
          </Box>
        ),
      },
    ]);

    const mappedInterventions = props.interventions.map(
      (intervention, index) => ({
        interventionKey: index,
        injurySufferedBy: intervention.injurySufferedBy,
        injury: intervention.injury,
        treatment: intervention.treatment,
        injurySufferedName: intervention.injurySufferedName,
        injuryTreatedBy: intervention.injuryTreatedBy,
      }),
    );

    setMappedInterventions(mappedInterventions);
  }, [props.interventions]);

  const previousPage = () => {
    props.previousPage(localIncidentValues);
  };

  const nextPage = () => {
    // if (!localIncidentValues.studentName.name) {
    // setStayOnTab(true)
    // } else {
    props.nextPage(localIncidentValues);
    // }
  };

  const submitForm = () => {
    // if (!localIncidentValues.studentName.name) {
    //   setStayOnTab(true)
    // } else {
    props.submitForm(localIncidentValues, 'Draft');
    // }
  };
  // auto save every 15 seconds
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     // buildTechniqueArray()
  //     props.submitForm(localIncidentValues, 'Draft')
  //   }, 15000)
  //   return () => clearInterval(interval) // Clear the interval on component unmount
  // }, [])

  const setDateTime = (date, time) => {
    setLocalIncidentValues(localIncidentValues => ({
      ...localIncidentValues,
      dateOfIncident: date,
      timeOfIncident: time || '12:00',
    }));
  };

  // Need to include this as it takes time for
  // props.incidentValues to get populated
  useEffect(() => {
    var propsToUpdate = props.incidentValues;
    // don't allow the student name to be replaced by the draft
    if (propsToUpdate.studentName && !propsToUpdate.studentName.id) {
      propsToUpdate.studentName = localIncidentValues.studentName;
    }
    setLocalIncidentValues(propsToUpdate);
  }, [props.incidentValues]);



  const getUserFromId = (id, type = 'serviceuser') => {
    if (!id || id === '' || id?.length <= 0) {
      return '';
    }
    var toSearch = String(id).split(',');
    var toReturn = [];
    for (const id of toSearch) {
      var thisString = '-';
      var match = false;
      if (type === 'serviceuser') {
        match = studentValues.find(u => {
          return parseInt(u.id) === parseInt(id);
        });
        if (match) {
          thisString = match.name || '';
        }
      } else {
        match = userValues.find(u => {
          return parseInt(u.id) === parseInt(id);
        });
        if (match) {
          thisString = match.name || '';
        }
      }
      toReturn.push(thisString);
    }

    return toReturn.join(',');
  };

  useEffect(() => {
    if (localIncidentValues.studentName.name) {
      props.getContacts(localIncidentValues.studentName.id);

      props.getIncidentPlans(localIncidentValues.studentName.id);
    }
  }, [localIncidentValues.studentName]);

  var sufferedByOptions = [];
  for (var thisField of constants.injurySufferedBy) {
    if (thisField?.includes('[Student]')) {
      thisField = thisField.replace(
        '[Student]',
        capitalize(terms?.serviceUser || 'Service User'),
      );
    }
    sufferedByOptions.push(thisField);
  }

  return (
    <Box
      gridArea="main"
      background="white"
      direction="column"
      gap="small"
      round="small"
    >
      <Box
        gap="small"
        margin={{ horizontal: 'small' }}
        pad="small"
        round="small"
      >
        <Box fill direction="row" gap="small">
          <H2 margin={{ vertical: 'none' }}>{getRecordTerm(terms, 'physicalReportTerm', 'Physical Intervention Report')}</H2>
          <Button
            label={
              <FontAwesome color="brand" icon={['fas', 'question-circle']} />
            }
            plain
            tip={`This is the first page of the ${getRecordTerm(terms, 'physicalReportTerm', 'Incident Report')}`}
          />
        </Box>
        <Divider color="primary" margin={{ top: 'none', bottom: 'small' }} />
        {props.studentValues && questions.length ? (
          <>
            {stayOnTab && (
              <NotificationLayer
                button1Text="OK"
                button1Click={() => {
                  setStayOnTab(false);
                }}
              >
                Please complete '{questions[0].questionText}' before continuing
              </NotificationLayer>
            )}

            <Form
              //   validate='blur'
              onChange={nextValue => {
                // Enable Intervention Add button if all fields have data
                setInterventionAddButton(
                  nextValue.injurySufferedBy !== '' &&
                    nextValue.injury !== '' &&
                    nextValue.treatment !== '' &&
                    nextValue.injurySufferedName !== '' &&
                    nextValue.injuryTreatedBy !== ''
                );

                setLocalIncidentValues(nextValue);
              }}
              onSubmit={e => {
                // if (e.nativeEvent.submitter.id === 'next') {
                  return nextPage();
                // } else if (e.nativeEvent.submitter.id === 'back') {
                  // return previousPage();
                // }
                // submitForm();
              }}
              value={localIncidentValues}
              validate="blur"
            >
              <ResponsiveGrid
                rows={['auto']}
                columns={{
                  small: ['auto'],
                  medium: ['auto', 'auto'],
                  large: ['auto', 'auto'],
                  xlarge: ['auto', 'auto', 'auto', 'auto'],
                }}
                gap="small"
              >
                {/* Student Name */}
                <FormField
                  label={questions[0].questionText}
                  name={questions[0].key}
                  required
                >
                    <Text>{`${
                      localIncidentValues?.studentName?.firstName || ''
                    } ${
                      localIncidentValues?.studentName?.lastName || ''
                    }`}</Text>
                </FormField>

                <FormField
                  label={questions[1].questionText}
                  name={questions[1].key}
                  required={true}
                >
                  {!editingDisabled && (
                    <DateTime
                      date={localIncidentValues.dateOfIncident}
                      time={localIncidentValues.timeOfIncident}
                      // name={questions[1].key}
                      setDateTime={setDateTime}
                    />
                  )}
                  {editingDisabled && (
                    <Text>{`${props.incidentValues?.dateOfIncident || ''} ${
                      localIncidentValues?.timeOfIncident || ''
                    }`}</Text>
                  )}
                </FormField>

                {/* Location */}
                <FormField
                  label={questions[3].questionText}
                  name={questions[3].key}
                  required
                >
                  {!editingDisabled && (
                    <LocationSelection
                      name={questions[3].key}
                      value={localIncidentValues?.[questions[3].key] || ''}
                      onChange={value => setLocalIncidentValues({ ...localIncidentValues, location: value })}
                    />
                  )}
                  {editingDisabled && (
                    <Text>
                      {localIncidentValues.location || 'N/A'}
                    </Text>
                  )}
                </FormField>

                {/* Session/Lesson */}
                <FormField
                  label={questions[35].questionText}
                  name={questions[35].key}
                >
                  {!editingDisabled && (
                    <TextInput
                      name={questions[35].key}
                      value={localIncidentValues?.[questions[35].key] || ''}
                      onChange={e => setLocalIncidentValues({ ...localIncidentValues, [questions[35].key]: e.target.value })}
                    />
                  )}
                  {editingDisabled && (
                    <Text>
                      {localIncidentValues?.[questions[35].key] || 'N/A'}
                    </Text>
                  )}
                </FormField>
              </ResponsiveGrid>

              <ResponsiveGrid
                rows={['auto']}
                columns={{
                  small: ['auto'],
                  medium: ['auto', 'auto'],
                  large: ['auto', 'auto', 'auto'],
                  xlarge: ['auto', 'auto', 'auto', 'auto'],
                }}
                gap="small"
              >
                {/* Completed By */}
                <FormField
                  label={questions[4].questionText}
                  name={questions[4].key}
                  required
                >
                  {!editingDisabled && (
                    <Select
                      // id='student'
                      name={questions[4].key}
                      labelKey="name"
                      placeholder="Completed by"
                      // onChange={({ option }) => changeOrganisation(option)}
                      clear={{ label: 'Clear Selection' }}
                      onSearch={text => {
                        // The line below escapes regular expression special characters:
                        // [ \ ^ $ . | ? * + ( )
                        const escapedText = text.replace(
                          /[-\\^$*+?.()|[\]{}]/g,
                          '\\$&',
                        );
                        // Create the regular expression with modified value which
                        // handles escaping special characters. Without escaping special
                        // characters, errors will appear in the console
                        const exp = new RegExp(escapedText, 'i');

                        setReportByValues(
                          props.userValues.filter(o => exp.test(o.name)),
                        );
                      }}
                      options={reportByValues}
                      valueKey={{ key: 'id', reduce: true }}
                    />
                  )}

                  {editingDisabled && (
                    <Text>
                      {getUserFromId(
                        props.incidentValues?.[questions[4].key],
                        'staff',
                      )}
                    </Text>
                  )}
                </FormField>

                {/* Staff Involved */}
                <FormField
                  label={questions[5].questionText}
                  name={questions[5].key}
                >
                  {!editingDisabled && (
                    <Select
                      // id='student'
                      name={questions[5].key}
                      labelKey="name"
                      multiple
                      placeholder="Staff Involved"
                      // onChange={({ option }) => changeOrganisation(option)}
                      options={staffInvolvedValues}
                      clear={{ label: 'Clear Selection' }}
                      onSearch={text => {
                        // The line below escapes regular expression special characters:
                        // [ \ ^ $ . | ? * + ( )
                        const escapedText = text.replace(
                          /[-\\^$*+?.()|[\]{}]/g,
                          '\\$&',
                        );
                        // Create the regular expression with modified value which
                        // handles escaping special characters. Without escaping special
                        // characters, errors will appear in the console
                        const exp = new RegExp(escapedText, 'i');

                        setStaffInvolvedValues(
                          props.userValues.filter(o => exp.test(o.name) || localIncidentValues?.staffInvolved?.includes(o.id))
                        );

                        // setStaffInvolvedValues(
                          // props.userValues.filter(o => exp.test(o.name)),
                        // );
                      }}
                      valueKey={{ key: 'id', reduce: true }}
                    />
                  )}
                  {editingDisabled && (
                    <Text>
                      {getUserFromId(
                        props.incidentValues?.[questions[5].key],
                        'staff',
                      ) || 'N/A'}
                    </Text>
                  )}
                </FormField>

                {/* Students Involved */}
                <FormField
                  label={questions[6].questionText}
                  name={questions[6].key}
                >
                  {!editingDisabled && (
                    <Select
                      // id='student'
                      name={questions[6].key}
                      labelKey="name"
                      multiple
                      placeholder={
                        (terms?.serviceUserPlural || 'Service users') +
                        ' involved'
                      }
                      clear={{ label: 'Clear Selection' }}
                      onSearch={text => {
                        // The line below escapes regular expression special characters:
                        // [ \ ^ $ . | ? * + ( )
                        const escapedText = text.replace(
                          /[-\\^$*+?.()|[\]{}]/g,
                          '\\$&',
                        );
                        // Create the regular expression with modified value which
                        // handles escaping special characters. Without escaping special
                        // characters, errors will appear in the console
                        const exp = new RegExp(escapedText, 'i');

                        setOtherServiceUserValues(
                          props.studentValues.filter(o => exp.test(o.name) || localIncidentValues?.studentsInvolved?.includes(o.id)),
                        );
                      }}
                      // onChange={({ option }) => changeOrganisation(option)}
                      options={otherServiceUserValues}
                      valueKey={{ key: 'id', reduce: true }}
                    />
                  )}
                  {editingDisabled && (
                    <Text>
                      {getUserFromId(
                        props.incidentValues?.[questions[6].key],
                        'serviceuser',
                      ) || 'N/A'}
                    </Text>
                  )}
                </FormField>

                {/* Witnesses */}
                <FormField
                  label={questions[7].questionText}
                  name={questions[7].key}
                >
                  {!editingDisabled && (
                    <TextInput
                      name={questions[7].key}
                      placeholder="Witnesses"
                      type="text"
                    />
                  )}
                  {editingDisabled && (
                    <Text>
                      {props.incidentValues?.[questions[7].key] || 'N/A'}
                    </Text>
                  )}
                </FormField>

              </ResponsiveGrid>

              <Box>
              <ResponsiveGrid
                rows={['auto']}
                columns={{
                  small: ['auto'],
                  medium: ['auto', 'auto'],
                  large: ['auto', 'auto', 'auto'],
                  xlarge: ['auto', 'auto', 'auto', 'auto'],
                }}
                gap="small"
              >
               {localIncidentValues?.staffInvolved?.length > 0 && <Box direction="column" gap="small">
                                {/* Allow collaborators */}
                                <FormField
                                  label={
                                    <Box height="40px"  style={{ 'margin-bottom': '20px' }}>{questions[34].questionText}</Box>
                                  }
                                  name={questions[34].key}
                                >
                                  {!editingDisabled && (
                                    <OptionButtons
                                      id={questions[34].key}
                                      name={questions[34].key}
                                      value={
                                        localIncidentValues.allowStaffToCollaborate || "Yes"
                                      }
                                    />
                                  )}
                                  {editingDisabled && (
                                    <Text>
                                      {props.incidentValues?.[questions[34].key] === 'Yes'
                                        ? 'Yes'
                                        : 'No'}
                                    </Text>
                                  )}
                                </FormField>
                              </Box>}

                <Box direction="column" gap="small">
                        {/* anybody injured medical intervention required ? */}
                  <FormField
                    label={
                      <Box height="40px"  style={{ 'margin-bottom': '20px' }}>{questions[27].questionText}</Box>
                    }
                    name={questions[27].key}
                    required
                  >
                    {!editingDisabled && (
                      <OptionButtons
                        id={questions[27].key}
                        name={questions[27].key}
                        value={
                          localIncidentValues.medicalInterventionRequired ||
                          'No'
                        }
                      />
                    )}
                    {editingDisabled && (
                      <Text>
                        {props.incidentValues?.[questions[27].key] === 'Yes'
                          ? 'Yes'
                          : 'No'}
                      </Text>
                    )}
                  </FormField>
                </Box>


              <Box direction="column" gap="small">
                    {/* physical intervention used ? */}
                    <FormField
                      label={
                        <>
                          <div style={{ 'margin-bottom': '20px' }}>
                            <Text style={questionTextStyle}>
                              {questions[28].questionText}
                            </Text>{' '}
                            <Button
                              label={
                                <Text>
                                  <FontAwesome
                                    color="brand"
                                    icon={['fas', 'question-circle']}
                                  />
                                </Text>
                              }
                              plain
                              tip={{
                                content: (
                                  <Box
                                    background={{ color: 'white' }}
                                    border={{ color: 'brand', size: 'small' }}
                                    direction="column"
                                    pad="small"
                                  >
                                    <Text>
                                      Minimal resistance eg a person is going with
                                      you willingly
                                    </Text>
                                  </Box>
                                ),
                              }}
                            />
                          </div>
                        </>
                      }
                      name={questions[28].key}
                      required
                    >
                      {!editingDisabled && (
                        <OptionButtons
                          id={questions[28].key}
                          name={questions[28].key}
                          value={
                            localIncidentValues.physicalInterventionUsed || 'No'
                          }
                        />
                      )}
                      {editingDisabled && (
                        <Text>
                          {props.incidentValues?.[questions[28].key] || ''}
                        </Text>
                      )}
                    </FormField>

                  </Box>

                  <Box direction="column" gap="small">


                    {/* restricted physical intervention used ? */}
                    <FormField
                      label={
                        <>
                          <div style={{ 'margin-bottom': '20px' }}>
                            <Text style={questionTextStyle}>
                              {questions[26].questionText}
                            </Text>{' '}
                            <Button
                              label={
                                <Text>
                                  <FontAwesome
                                    color="brand"
                                    icon={['fas', 'question-circle']}
                                  />
                                </Text>
                              }
                              plain
                              tip={{
                                content: (
                                  <Box
                                    background={{ color: 'white' }}
                                    border={{ color: 'brand', size: 'small' }}
                                    direction="column"
                                    pad="small"
                                  >
                                    <Text>
                                      If an individual is resisting and force is
                                      used it becomes restrictive physical
                                      intervention.
                                    </Text>
                                  </Box>
                                ),
                              }}
                            />
                          </div>
                        </>
                      }
                      name={questions[26].key}
                      required
                    >
                      {!editingDisabled && (
                        <OptionButtons
                          id={questions[26].key}
                          name={questions[26].key}
                          value={
                            localIncidentValues.restrictedPhysicalInterventionUsed ||
                            'No'
                          }
                        />
                      )}
                      {editingDisabled && (
                        <Text>
                          {props.incidentValues?.[questions[26].key] || ''}
                        </Text>
                      )}
                    </FormField>

                  </Box>

                  <Box direction="column" gap="small">
                    {/* Was your action in the best interest of the service user? */}
                    <FormField
                      label={
                        <Box height="40px" style={{ 'margin-bottom': '20px' }}>{questions[15].questionText}</Box>
                      }
                      name={questions[15].key}
                    >
                      {!editingDisabled && (
                        <OptionButtons
                          id={questions[15].key}
                          name={questions[15].key}
                          options={['Yes', 'No', "N/A"]}
                          value={localIncidentValues.bestInterestQuestion || 'Yes'}
                        />
                      )}
                      {editingDisabled && (
                        <Text>
                          {props.incidentValues?.[questions[15].key] || 'Yes'}
                        </Text>
                      )}
                    </FormField>

                  </Box>
                </ResponsiveGrid>
                { localIncidentValues.bestInterestQuestion !== "N/A" && <ResponsiveGrid
                rows={['auto']}
                columns={{
                  small: ['auto'],
                  medium: ['auto'],
                  large: ['auto'],
                  xlarge: ['auto'],
                }}
                gap="small"
              >

                <Box direction="column" gap="small">
                  {/* Why was this [not] in the best interest of the service user? */}
                  <FormField
                    label={`Why was this ${
                      localIncidentValues.bestInterestQuestion === 'No'
                        ? 'not'
                        : ''
                    }  in the best interest of the ${lowercase(terms?.serviceUser || 'service user')}?`}
                    name={questions[16].key}
                  >
                    {!editingDisabled && <TextArea name={questions[16].key} />}
                    {editingDisabled && (
                      <Text>
                        {localIncidentValues.bestInterest || 'N/A'}
                      </Text>
                    )}
                  </FormField>

                </Box>

              </ResponsiveGrid>}
              </Box>


                {(localIncidentValues.restrictedPhysicalInterventionUsed === 'Yes' || localIncidentValues.physicalInterventionUsed === 'Yes') && <ResponsiveGrid
                rows={['auto']}
                columns={{
                  small: ['auto'],
                  medium: ['auto', 'auto'],
                  large: ['auto', 'auto', 'auto'],
                  xlarge: ['auto', 'auto', 'auto', 'auto'],
                }}
                gap="small"
              >

                <Box direction="column">
                  {/* Hurting Self */}
                  <FormField
                    label={<Box height="40px">{questions[8].questionText}</Box>}
                    name={questions[8].key}
                  >
                    {!editingDisabled && (
                      <OptionButtons
                        id={questions[8].key}
                        name={questions[8].key}
                        value={localIncidentValues.hurtingSelf || 'N/A'}
                      />
                    )}
                    {editingDisabled && (
                      <Text>
                        {localIncidentValues.hurtingSelf || 'N/A'}
                      </Text>
                    )}
                  </FormField>

                    {/* Other Behaviour we are trying to support */}
                    <FormField
                      label={
                        <Box height="40px">{questions[12].questionText}</Box>
                      }
                      name={questions[12].key}
                    >
                      {!editingDisabled && (
                        <OptionButtons
                          id={questions[12].key}
                          name={questions[12].key}
                          value={localIncidentValues.behaviour || 'N/A'}
                        />
                      )}
                      {editingDisabled && (
                        <Text>
                          {localIncidentValues.behaviour || 'N/A'}
                        </Text>
                      )}
                    </FormField>

                </Box>

                <Box direction="column">

                  {/* Hurting Others */}
                  <FormField
                    label={<Box height="40px">{questions[9].questionText}</Box>}
                    name={questions[9].key}
                  >
                    {!editingDisabled && (
                      <OptionButtons
                        id={questions[9].key}
                        name={questions[9].key}
                        value={localIncidentValues.hurtingOthers || 'N/A'}
                      />
                    )}
                    {editingDisabled && (
                      <Text>
                        {localIncidentValues.hurtingOthers || 'N/A'}
                      </Text>
                    )}
                  </FormField>

                </Box>

                <Box direction="column">

                  {/* Damage to property */}
                  <FormField
                    label={
                      <Box height="40px">{questions[11].questionText}</Box>
                    }
                    name={questions[11].key}
                  >
                    {!editingDisabled && (
                      <OptionButtons
                        id={questions[11].key}
                        name={questions[11].key}
                        value={localIncidentValues.propertyDamage || 'N/A'}
                      />
                    )}
                    {editingDisabled && (
                      <Text>
                        {localIncidentValues.propertyDamage || 'N/A'}
                      </Text>
                    )}
                  </FormField>

                </Box>

                <Box direction="column">

                  {/* Committing an offence */}
                  <FormField
                    label={
                      <Box height="40px">{questions[10].questionText}</Box>
                    }
                    name={questions[10].key}
                  >
                    {!editingDisabled && (
                      <OptionButtons
                        id={questions[10].key}
                        name={questions[10].key}
                        value={localIncidentValues.commitOffence || 'N/A'}
                      />
                    )}
                    {editingDisabled && (
                      <Text>{localIncidentValues.commitOffence || 'N/A'}</Text>
                    )}
                  </FormField>

                </Box>
              </ResponsiveGrid>}

              {(localIncidentValues.restrictedPhysicalInterventionUsed === 'Yes' || localIncidentValues.physicalInterventionUsed === 'Yes') && <Box>
                <ResponsiveGrid
                  rows={['auto']}
                  columns={{
                    small: ['auto'],
                    medium: ['auto', 'auto'],
                    large: ['auto', 'auto', 'auto'],
                    xlarge: ['auto', 'auto', 'auto', 'auto'],
                  }}
                  gap="small"
                >
                  <Box direction="column" gap="small">

                    {/* dynamicRisk? */}
                    <FormField
                      label={<Box height="40px" style={{ 'margin-bottom': '20px' }}>{questions[17].questionText}</Box>}
                      name={questions[17].key}
                    >
                      {!editingDisabled && (
                        <OptionButtons
                          id={questions[17].key}
                          name={questions[17].key}
                          value={localIncidentValues.dynamicRisk || 'N/A'}
                        />
                      )}
                      {editingDisabled && (
                        <Text>
                          {localIncidentValues.dynamicRisk || 'N/A'}
                        </Text>
                      )}
                    </FormField>
                </Box>
                <Box direction="column" gap="small">

                      {/* followPlan */}
                      <FormField
                      label={
                        <Box height="40px" style={{ 'margin-bottom': '20px' }}>{questions[13].questionText}</Box>
                      }
                      name={questions[13].key}
                    >
                      {!editingDisabled && (
                        <OptionButtons
                          id={questions[13].key}
                          name={questions[13].key}
                          value={localIncidentValues.followPlanQuestion || 'N/A'}
                        />
                      )}
                      {editingDisabled && (
                        <Text>
                          {localIncidentValues.followPlanQuestion || 'N/A'}
                        </Text>
                      )}
                    </FormField>
                  </Box>


                  </ResponsiveGrid>
              </Box>}
              {(localIncidentValues.restrictedPhysicalInterventionUsed === 'Yes' || localIncidentValues.physicalInterventionUsed === 'Yes') &&
              <Box>
              <ResponsiveGrid
                  rows={['auto']}
                  columns={{
                    small: ['auto'],
                    medium: ['auto', 'auto'],
                    large: ['auto', 'auto', 'auto'],
                    xlarge: ['auto', 'auto', 'auto', 'auto'],
                  }}
                  gap="small"
                >

                {localIncidentValues.dynamicRisk === 'Yes' && (
                <Box direction="column" gap="small">

                     {/* Dynamic risk information */}

                      <FormField
                        label={
                          <Box height="40px" style={{ 'margin-bottom': '20px' }}>{questions[18].questionText}</Box>
                        }
                        name={questions[18].key}
                      >
                        {!editingDisabled && (
                          <TextArea style={{ height: '44px' }} name={questions[18].key} />
                        )}
                        {editingDisabled && (
                          <Text>
                            {localIncidentValues.dynamicRiskInformation || 'N/A'}
                          </Text>
                        )}
                      </FormField>


                </Box>)}
                <Box direction="column" gap="small">
                  {(!localIncidentValues.followPlanQuestion ||
                      localIncidentValues.followPlanQuestion === 'No') && (
                      // followPlan - Please Elaborate
                      <FormField
                        label={
                          <Box height="40px" style={{ 'margin-bottom': '20px' }}>{questions[14].questionText}</Box>
                        }
                        name={questions[14].key}
                      >
                        {!editingDisabled && (
                          <TextArea
                            style={{ height: '44px' }}
                            name={questions[14].key}
                            fill
                          />
                        )}
                        {editingDisabled && (
                          <Text>
                            {localIncidentValues.followPlanResponse || 'N/A'}
                          </Text>
                        )}
                      </FormField>
                    )}
                </Box>
              </ResponsiveGrid>
               <ResponsiveGrid
                  rows={['auto']}
                  columns={{
                    small: ['auto'],
                    medium: ['auto', 'auto'],
                    large: ['auto', 'auto', 'auto'],
                    xlarge: ['auto', 'auto', 'auto', 'auto'],
                  }}
                  gap="small"
                >

                {localIncidentValues.restrictedPhysicalInterventionUsed ===
                  'Yes' && (
                    <>
                    {/* Breathing monitored */}
                    <FormField
                      label={
                        <Box height="40px">{questions[19].questionText}</Box>
                      }
                      name={questions[19].key}
                      required
                    >
                      {!editingDisabled && (
                        <RadioButtonGroup
                          direction="row"
                          name={questions[19].key}
                          // onChange={event =>
                          //   setActionButton(event.target.value)}
                          options={['Yes', 'No']}
                        >
                          {(option, { checked, hover }) => {
                            let background;
                            if (checked) background = 'brand';
                            else if (hover) background = 'light-4';
                            else background = 'light-2';
                            return (
                              <Box background={background} pad="small">
                                {option}
                              </Box>
                            );
                          }}
                        </RadioButtonGroup>
                      )}
                      {editingDisabled && (
                        <Text>
                          {localIncidentValues.breathingMonitored || 'N/A'}
                        </Text>
                      )}
                    </FormField>

                    {/* Duration */}
                    <FormField
                      label={
                        <Box height="40px">{questions[20].questionText}</Box>
                      }
                      name={questions[20].key}
                      required
                    >
                      {!editingDisabled && (
                        <TextInput name={questions[20].key} type="number" />
                      )}
                      {editingDisabled && (
                        <Text>
                          {localIncidentValues.physicalInterventionDuration || 'N/A'}
                        </Text>
                      )}
                    </FormField>

                    {/* Number of staff */}
                    <FormField
                      label={
                        <Box height="40px">{questions[21].questionText}</Box>
                      }
                      name={questions[21].key}
                      required
                    >
                      {!editingDisabled && (
                        <TextInput name={questions[21].key} type="number" />
                      )}
                      {editingDisabled && (
                        <Text>
                          {localIncidentValues.numberStaffInvolved || 'N/A'}
                        </Text>
                      )}
                    </FormField>
                  </>
                )}
              </ResponsiveGrid>

              </Box>}
              {localIncidentValues.medicalInterventionRequired === 'Yes' && (
                  <>
                    <Box direction="row-responsive" gap="medium">
                      <DataTable
                        columns={interventionColumns}
                        data={mappedInterventions}
                        fill="horizontal"
                        primaryKey={false}
                        size="large"
                      />
                    </Box>
                    {!editingDisabled && <Box direction="row-responsive" gap="medium">
                      {/* Injury Suffered By */}
                      <FormField
                        label={questions[22].questionText}
                        name={questions[22].key}
                      >
                        {!editingDisabled && (
                          <Select
                            name={questions[22].key}
                            options={sufferedByOptions}
                          />
                        )}
                        {editingDisabled && (
                          <Text>
                            {localIncidentValues.injurySufferedBy || 'N/A'}
                          </Text>
                        )}
                      </FormField>

                      <FormField
                        label={questions[23].questionText}
                        name={questions[23].key}
                      >
                        {!editingDisabled && (
                          <TextInput name={questions[23].key} type="text" />
                        )}
                        {editingDisabled && (
                          <Text>
                            {localIncidentValues.injury || 'N/A'}
                          </Text>
                        )}
                      </FormField>

                      <FormField
                        label={questions[24].questionText}
                        name={questions[24].key}
                      >
                        {!editingDisabled && (
                          <TextInput name={questions[24].key} type="text" />
                        )}
                        {editingDisabled && (
                          <Text>
                            {localIncidentValues.treatment || 'N/A'}
                          </Text>
                        )}
                      </FormField>

                      <FormField
                        label={questions[29].questionText}
                        name={questions[29].key}
                      >
                        {!editingDisabled && (
                          <TextInput name={questions[29].key} type="text" />
                        )}
                        {editingDisabled && (
                          <Text>
                            {localIncidentValues.injurySufferedName || 'N/A'}
                          </Text>
                        )}
                      </FormField>

                      <FormField
                        label={questions[30].questionText}
                        name={questions[30].key}
                      >
                        {!editingDisabled && (
                          <TextInput name={questions[30].key} type="text" />
                        )}
                        {editingDisabled && (
                          <Text>
                            {localIncidentValues.injuryTreatedBy || 'N/A'}
                          </Text>
                        )}
                      </FormField>

                      {!editingDisabled && (
                        <ActionButton
                          disabled={!interventionAddButton}
                          label={
                            <Text>
                              <FontAwesome icon={['fal', 'plus-circle']} />
                            </Text>
                          }
                          color="primary"
                          onClick={() => addIntervention()}
                          style={{ height: '35px' }}
                          alignSelf="end"
                          margin={{ bottom: 'small' }}
                        />
                      )}
                    </Box>}
                  </>
                )}
              {(localIncidentValues.restrictedPhysicalInterventionUsed ===
                'Yes' || localIncidentValues.physicalInterventionUsed ===
                'Yes' ||
                localIncidentValues.medicalInterventionRequired === 'Yes') && (
                <FormField
                  label={questions[25].questionText}
                  name={questions[25].key}
                >
                  {!editingDisabled && <TextArea name={questions[25].key} />}
                  {editingDisabled && (
                    <Text>
                      {localIncidentValues.otherConcerns || 'N/A'}
                    </Text>
                  )}
                </FormField>
              )}

              {localIncidentValues.medicalInterventionRequired === 'Yes' && (
                <Box direction="row-responsive" gap="medium">
                  {/* First Aid Form */}
                    <FormField
                      label={questions[32].questionText}
                      name={questions[32].key}
                  >
                    {!editingDisabled && (
                      <OptionButtons
                      id={questions[32].key}
                      name={questions[32].key}
                      options={['Yes', 'No', "N/A"]}
                      value={localIncidentValues.firstAidFormCompleted || 'N/A'}
                    />
                    )}
                    {editingDisabled && (
                      <Text>
                        {props.incidentValues?.[questions[32].key] || 'N/A'}
                      </Text>
                    )}

                  </FormField>

                  {/* Why not First Aid Form */}
                  {localIncidentValues.firstAidFormCompleted === 'No' && <FormField
                    label={questions[33].questionText}
                    name={questions[33].key}
                    required
                  >
                    {!editingDisabled && <TextArea
                      name={questions[33].key}
                    />}
                    {editingDisabled && <Text>{props.incidentValues?.[questions[33].key] || ''}</Text>}
                  </FormField>}
              </Box>
            )}

            {!editingDisabled && localIncidentValues.bestInterestQuestion === 'No' && <ResponsiveGrid
                  rows={['auto']}
                  columns={{
                    small: ['auto'],
                    medium: ['auto', 'auto'],
                    large: ['75%', '25%'],
                    xlarge: ['75%', '25%'],
                  }}
                  style={{
                    padding: '20px',
                    background: 'rgba(255, 0, 0, 0.05)',

                  }}
                  gap="small"
                  border={{ color: 'primary', size: 'small' }}
                >
                  <Box direction="column" gap="small" padding='20px'>
                    <Box style={{ 'margin-bottom': '20px', 'font-weight': 'bold' }}>
                      <Text color='secondary'>{questions[31].questionText}</Text>
                    </Box>
                  </Box>
              <Box direction="row" gap="small">
                {/* Was your action in the best interest of the service user? */}
                <FormField
                  name={questions[31].key}
                >
                  {!editingDisabled && (
                    <OptionButtons
                      id={questions[31].key}
                      name={questions[31].key}
                      value={localIncidentValues.bestInterestConfirmQuestion || 'No'}
                    />
                  )}
                  {editingDisabled && (
                    <Text>
                      {localIncidentValues.bestInterestConfirmQuestion || 'N/A'}
                    </Text>
                  )}
                </FormField>

              </Box>
            </ResponsiveGrid>}

            {/* Action Agreed / Responsible for follow-up / Parent's Contacted */}
            {/* <ResponsiveGrid
                  rows={['auto']}
                  columns={{
                    small: ['auto'],
                    medium: ['auto'],
                    large: ['auto', 'auto'],
                    xlarge: ['auto', 'auto'],
                  }}
                  gap="small"
                >
              <FormField
                label={questions[36].questionText}
                name={questions[36].key}
              >
                {!editingDisabled && (
                  <TextArea
                    name={questions[36].key}
                    value={localIncidentValues?.[questions[36].key] || ''}
                    onChange={e => setLocalIncidentValues({ ...localIncidentValues, [questions[36].key]: e.target.value })}
                  />
                )}
                {editingDisabled && (
                  <Text>
                    {localIncidentValues?.[questions[36].key] || 'N/A'}
                  </Text>
                )}
              </FormField>
              <FormField
                label={questions[37].questionText}
                name={questions[37].key}
              >
                {!editingDisabled && (
                  <TextArea
                    name={questions[37].key}
                    value={localIncidentValues?.[questions[37].key] || ''}
                    onChange={e => setLocalIncidentValues({ ...localIncidentValues, [questions[37].key]: e.target.value })}
                  />
                )}
                {editingDisabled && (
                  <Text>
                    {localIncidentValues?.[questions[37].key] || 'N/A'}
                  </Text>
                )}
              </FormField>
            </ResponsiveGrid> */}

              <CommentsForm formId={props.formId} userId={props.userId} section={props.section} isCollaborator={props.allowCollaboration} />


              <Divider
                color="primary"
                margin={{ top: 'medium', bottom: 'none' }}
              />

              <Box
                direction="row"
                gap="small"
                justify="between"
                margin={{ top: 'medium' }}
              >
                <ActionButton id="back" label="< Back" secondary onClick={previousPage} />
                {!editingDisabled && (
                  <ActionButton
                    type="submit"
                    icon={<FontAwesome icon={['fal', 'save']} color="#fff" />}
                    label="Save for later"
                  />
                )}

                {!editingDisabled && <>
                  {!(localIncidentValues.bestInterestQuestion === 'No' && localIncidentValues.bestInterestConfirmQuestion === 'No') ?
                      <ActionButton id="next" type="submit" label="Next Page" primary />
                    :
                    <Text>Missing required field</Text>}
                  </>
                }

                {editingDisabled && <ActionButton id="next" label="Next Page" primary onClick={nextPage} />}


              </Box>
            </Form>
          </>
        ) : (
          <Box align="center">
            <PulseLoader size={15} color="orange" loading={loading} />
          </Box>
        )}
      </Box>
    </Box>
  );
}
export default IncidentReport;
